import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import React, { useCallback, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import cx from 'classnames';
import styles from './drag-and-drop.less';

const makeDataKey = data => ({
  key: _uniqueId('data'),
  value: data,
});

const CommonDragAndDrop = ({
  rawData,
  renderFunc,
  customStyles,
  onDragEndFunc,
}) => {
  const [dataFields, setDataFields] = useState([]);

  useEffect(
    () => {
      // Init data field with key
      if (rawData && rawData.length > 0) {
        const dataFieldsWithKey = rawData.map(makeDataKey);
        setDataFields(dataFieldsWithKey);
      }
    },
    [rawData, setDataFields],
  );

  const onDragEnd = useCallback(
    result => {
      onDragEndFunc(result);
    },
    [onDragEndFunc],
  );

  const draggableRender = useCallback(
    (dataField, index) => (
      <Draggable key={dataField.key} draggableId={dataField.key} index={index}>
        {innerProvided => (
          <div {...innerProvided.draggableProps} ref={innerProvided.innerRef}>
            <div
              key={dataField.key}
              className={cx(styles.draggable, customStyles)}
              {...innerProvided.dragHandleProps}
            >
              {renderFunc(dataField.value, index)}
            </div>
          </div>
        )}
      </Draggable>
    ),
    [renderFunc],
  );

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={'droppable'}>
        {provided => (
          <div
            {...provided.droppableProps}
            id={_uniqueId('dragdrop')}
            ref={provided.innerRef}
          >
            {dataFields.map(draggableRender)}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

CommonDragAndDrop.defaultProps = {
  customStyles: undefined,
  onDragEndFunc: undefined,
};

CommonDragAndDrop.propTypes = {
  rawData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  renderFunc: PropTypes.func.isRequired,
  customStyles: PropTypes.string,
  onDragEndFunc: PropTypes.func,
};

export default CommonDragAndDrop;
